import React from 'react';

interface ComponentHeaderProps {
  title: string;
  subtitle?: string;
  status?: string;
  statusColor?: string;
  statusBgColor?: string;
  icon?: React.ComponentType<{ className?: string }>;
  children?: React.ReactNode;
}

export const ComponentHeader: React.FC<ComponentHeaderProps> = ({
  title,
  subtitle,
  status,
  statusColor = 'text-slate-600',
  statusBgColor = 'bg-slate-100',
  icon: Icon,
  children
}) => {
  return (
    <div className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-200 rounded-lg overflow-hidden">
      <div className="relative bg-gradient-to-r from-slate-500 to-slate-600 text-white p-2">
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-white/30"></div>
        
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            {status && (
              <div className="flex items-center gap-2 mb-1">
                <span className={`px-1.5 py-0.5 text-xs font-semibold rounded-full ${statusBgColor} ${statusColor} border border-white/20 shadow-sm bg-opacity-90`}>
                  {Icon && <Icon className="w-2.5 h-2.5 inline mr-1" />}
                  {status}
                </span>
              </div>
            )}
            
            <h2 className="text-sm font-bold text-white mb-1">
              {title}
            </h2>
            
            {subtitle && (
              <div className="flex items-center gap-2 text-white/90">
                <span className="text-xs font-medium text-white truncate min-w-0">
                  {subtitle}
                </span>
              </div>
            )}
            
            {children}
          </div>
        </div>
      </div>

      {status && (
        <div className={`flex items-center justify-center gap-1 py-1 text-xs font-semibold ${statusColor} bg-white/10`}>
          {Icon && <Icon className="w-2.5 h-2.5" />}
          <span>{status}</span>
        </div>
      )}
    </div>
  );
};
